import React, { useState, useEffect } from "react"
import { navigate } from "gatsby"

import { Navbar, Nav, Form, FormControl, Button } from "react-bootstrap"
import { FaSearch } from 'react-icons/fa';
import Logo from "../assets/ilir-logo-new4.svg";
import Pluralize from '../../experimental/pluralize'

import { categories } from '../components/categoryInfo' 

function normalize_search_text ( search_text ) {
  var out_text = ""
  if (search_text !== undefined) {
    var stringArray = search_text.split(/(\s+)/)
    for (var i =0; i < stringArray.length; i++) {
      if (stringArray[i] !== ' ') {
        //console.log('checking word: X:'+stringArray[i]+':X => ' + Pluralize.singular(stringArray[i]))
        out_text = out_text + Pluralize.singular(stringArray[i]) + ' '
      }
    }
  }
  return out_text
}

const keyword_map = [
  { keyword: "about", link: "/about/"},
  { keyword: "bbq", link: "/recipes/view/category/grilling-and-bbq/"},
  { keyword: "browse", link: "/recipe-index/"},
  { keyword: "camping", link: "/camping-cookbook/"},
  { keyword: "camping cookbook", link: "/camping-cookbook/"},
  { keyword: "child", link: "/recipes/view/category/kid-friendly/"},
  { keyword: "cookbook", link: "/cookbooks/"},
  { keyword: "crockpot", link: "/recipes/view/category/slow-cooker/"},
  { keyword: "family cookbook", link: "/menke-family-cookbook/"},
  { keyword: "grilling", link: "/recipes/view/category/grilling-and-bbq/"},
  { keyword: "hotdish", link: "/recipes/view/category/casseroles/"},
  { keyword: "hot-dish", link: "/recipes/view/category/casseroles/"},
  { keyword: "kid", link: "/recipes/view/category/kid-friendly/"},
  { keyword: "menke family cookbook", link: "/menke-family-cookbook/"},
  { keyword: "outdoor", link: "/recipes/view/category/outdoor-cooking/"},
]

const CustomNavbar = ({ pageInfo, additionalNavBar }) => {
  const [searchQuery, setSearchQuery] = useState('');
  //console.log(pageInfo)

  useEffect(() => {
    setSearchQuery(pageInfo?.searchQuery)
  }, [pageInfo?.searchQuery]);

  const doSearch = e => {
    //history.push(`?s=${searchQuery}`)
    e.preventDefault()
    if (searchQuery !== undefined) {

      const normalized_query = normalize_search_text(searchQuery.toLowerCase()).trim()
      console.log('normalized query='+normalized_query)
      const category_match = categories.find( category =>  category.normalized === normalized_query)
      const keyword_match = keyword_map.find( item =>  item.keyword === normalized_query)
    
      if (keyword_match !== undefined) {
        navigate(keyword_match.link, { state: { searchQuery }}) 
      } else if (category_match !== undefined) {
        navigate("/recipes/view/category/"+category_match.link, { state: { searchQuery }})
      } else {
        navigate('/search',{ state: { searchQuery, normalizedQuery: normalized_query }})
      } 

    }
  };

  return (
    <>
      <div id="site-navbar5">
      <Navbar expand="md" id="site-navbar-search">
        <div className="d-flex flex-column  flex-grow-1">
          <div className="d-flex flex-grow-1">
          <div className="d-flex justify-content-center flex-grow-1">
            <Navbar.Brand href="/" className="ps-2 pb-1 pt-0 me-0"><Logo id="navbar-logo1"/></Navbar.Brand>
            <Navbar.Brand href="/" className="pt-2"><Logo id="navbar-logo2"/></Navbar.Brand>
            <Form inline="true" id="navbar-search-form" className="d-flex flex-shrink-1" onSubmit={doSearch}>
              <FormControl
                  type="text"
                  placeholder="Search Recipes"
                  className="mr-2"
                  id="recipe-search"
                  defaultValue={pageInfo?.searchQuery}
                  onChange={(event) => setSearchQuery(event.target.value) }
              />
              <Button id="recipe-search-button" onClick={doSearch} variant="secondary"><FaSearch /></Button>
            </Form>
           
            <div className="me-2 ps-1" id="hamburger-menu-icon">
                  <Navbar.Toggle aria-controls="basic-navbar-nav" className="me-2" id="hamburger-menu-toggle" />
            </div>  

          </div>
          </div>
          <div id="site-navbar-menu">
                <Navbar.Collapse id="basic-navbar-nav" className="justify-content-center flex-shrink-1">
                  <div className="d-flex justify-content-end"><Nav.Link href="/">Home</Nav.Link></div>
                  <div className="d-flex justify-content-end"><Nav.Link href="/recipe-index">Browse Recipes</Nav.Link></div>
                  <div className="d-flex justify-content-end"><Nav.Link href="/camping-cookbook">Camping Cookbook</Nav.Link></div>
                  <div className="d-flex justify-content-end"><Nav.Link href="/menke-family-cookbook">Family Cookbook</Nav.Link></div>
                  <div className="d-flex justify-content-end"><Nav.Link href="/about">About</Nav.Link></div>
                </Navbar.Collapse>
          </div>
        
        </div>
      </Navbar>
      { additionalNavBar === undefined ? <></> :
        <Navbar id="site-navbar-additional">
        <div className="d-flex justify-content-center">
          {additionalNavBar}
        </div>
        </Navbar>
      }
      </div>
    </>
  )
}

export default CustomNavbar
